<template>
  <div>
    <ContentHeader :order-nav="true" :show-back="false" />

    <div class="content-container" v-loading="listLoading">
      <QueryPanel order-type="freezer" @search="searchOrder" />

      <div class="order-list" >
        <OrderLineFreezer @reload="queryOrderList" v-for="order in orderList" :key="order.orderId" :order-info="order" :order-type="'freezer'"/>
      </div>
      <div class="pag-row" v-if="orderList.length">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="queryParam.page"
          :page-size="queryParam.pageSize"
          :total="total"
          @current-change="handleCurrentChange"
        />
      </div>

      <div v-else class="no-data">
        暂无数据
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '@/components/content-header'
import QueryPanel from './components/query-panel'
import OrderLineFreezer from './components/order-line-freezer'
export default {
  name: 'order-list-freezer',
  components: {
    ContentHeader,
    QueryPanel,
    OrderLineFreezer
  },
  data () {
    return {
      total: null,
      listLoading: false,
      queryParam: {
        page: 1,
        pageSize: 10,
        orderNumber: '',
        orderStatus: '',
        orderDateFrom: '',
        orderDateTo: '',
        isIce: '',
        receivePerson: '',
        receivePhone: '',
        supplierName: ''
      },
      orderList: []
    }
  },
  created () {
    this.queryOrderList()
  },
  methods: {
    searchOrder (param) {
      this.queryParam.orderNumber = param.orderNumber
      this.queryParam.orderStatus = param.orderStatus
      this.queryParam.orderDateFrom = param.orderDateFrom
      this.queryParam.orderDateTo = param.orderDateTo
      this.queryParam.isIce = param.isIce
      this.queryParam.receivePerson = param.receivePerson
      this.queryParam.receivePhone = param.receivePhone
      this.queryParam.supplierName = param.supplierName
      this.queryOrderList()
    },
    queryOrderList () {
      this.queryParam.orderType = '01'
      this.listLoading = true
      this.$store.dispatch('queryQuotaOrderList', this.queryParam).then(res => {
        this.listLoading = false
        if (res.data.resultCode === '0') {
          this.orderList = res.data.resultData.quotaOrderList || []
          this.total = res.data.resultData.pageInfo.totalCounts
          this.orderList.forEach(item => {
            item.detailList.forEach(detail => {
              this.$set(detail, 'detailStatusName', item.orderStatusName)
              this.$set(detail, 'orderStatus', item.orderStatus)
            })
          })
        }
      }).catch(() => {
        this.listLoading = false
      })
    },
    handleCurrentChange (val) {
      this.queryParam.page = val
      this.queryOrderList()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
